import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import store from "@/store";
import * as types from "@/store/constants/types";
import { formatCookie } from "@/api/http/utils/apiHelpers";
import Http from "@/api/http/fetch/index";
import * as statusConst from "@/store/constants/status";
/**
 * 添加的拦截器功能：
 * 1.cookie的拦截管理，请求前后的存储； 2.返回结果的拦截； 3.header的默认设置
 */

import { iosHeaders, baseUrl } from "@/api/http/ins/insConst";
//=================== [REQUEST] ===============================

/**
 * 添加默认的IOS Header头
 */
export const defaultHeader = async (config: any) => {
  // console.log("defaultHeader config:", config);
  // console.log("defaultHeader iosHeaders:", iosHeaders());

  if (config.hasOwnProperty("headers")) {
    // console.log("如果有默认的headers");
    const newHeaders = {
      ...config.headers,
      ...iosHeaders()
    };
    return {
      ...config,
      headers: newHeaders
    };
  } else {
    // console.log("如果no默认的headers");
    config.headers = iosHeaders();
    return config;
  }
};

/**
 * 请求headers中加入cookies
 * @param request
 */
export const requestCookiePreLoad = async (request: any) => {
  // console.log("requestCookiePreLoad:", request);
  try {
    if (
      request.hasOwnProperty("userId") &&
      store.getters[types.GETTER_COOKIE_BY_USER_ID](request.userId) != null
    ) {
      const preLoadCookie = formatCookie(
        store.getters[types.GETTER_COOKIE_BY_USER_ID](request.userId)
      );
      request.headers.Cookie = preLoadCookie;
      return request;
    } else {
      //如果找不到cookie,默认获取cookie list中的第一个
      // console.log("如果找不到cookie,默认获取cookie list中的第一个", request);
      if (request.hasOwnProperty("cookieHandle") && !request.cookieHandle) {
        //如果不要默认注入cookie
        // console.log("如果找不到cookie,如果不要默认注入cookie", request);
        return request;
      }
      if (request.hasOwnProperty("chainCookie") && request.chainCookie) {
        const result: any = await Http.GetCookie(baseUrl);
        const words = Base64.parse(result);
        const textString = Utf8.stringify(words);
        const lastWord = JSON.parse(textString);
        // console.log("resultresultresult:", lastWord);
        request.headers.Cookie = formatCookie(lastWord);
        return request;
      }

      if (store.getters[types.GETTER_MASTER_COOKIE]) {
        request.headers.Cookie = formatCookie(
          store.getters[types.GETTER_MASTER_COOKIE]
        );
      }
      return request;
    }
  } catch (error) {
    return request;
  }
};

//==================== [RESPONSE] =============================

/**
 * 对请求后的response进行处理解析
 */
export function defaultResponse(response: any) {
  if (response.hasOwnProperty("data")) {
    return JSON.parse(response.data);
  } else {
    return response;
  }
}
/**
 * 对请求后返回的cookie header进行处理，存储到对应的store内,在请求是成功的条件下：
 * @param response
 */
export const responseCookieFactory = async (response: any) => {
  if (
    response.hasOwnProperty("cookies") &&
    response.cookies !== "" &&
    response.status === "ok"
  ) {
    let { cookies } = response;
    const words = Base64.parse(cookies);
    const textString = Utf8.stringify(words);
    cookies = JSON.parse(textString);
    // console.log("经过 responseCookieFactory的cookies:", cookies);

    // let cookiesData: any;
    // const data: any = await Http.GetCookie(baseUrl);
    // cookiesData = JSON.parse(Utf8.stringify(Base64.parse(data)));
    // console.log("原生给的cookie: ", cookiesData);
    if (cookies.hasOwnProperty("ds_user_id")) {
      //手动merge cookie 的数据:
      store.commit(types.UPDATE_INS_COOKIE_BY_USER_ID, {
        userId: parseInt(cookies.ds_user_id),
        cookie: cookies
      });
    }
    return response;
  } else {
    return response;
  }
};

export function responseErrorToReject(response: any) {
  console.log("responseErrorToReject response:", response);
  if (response.hasOwnProperty("status") && response.status === "fail") {
    //如果此时触发了 Login required 需要改变此用户的状态：

    if (
      response.error &&
      typeof response.error === "object" &&
      response.error.message
    ) {
      if (
        response.error.message === "challenge_required" ||
        response.error.message === "checkpoint_required" ||
        response.error.message === "login_required"
      ) {
        console.log("触发了challenge_required:", response);
        if (response.userId) {
          //更新ins的userStatus:
          let newUserStatus = store.getters[types.GETTER_USER_STATUS_BY_ID](
            response.userId
          );
          if (newUserStatus) {
            newUserStatus = {
              ...newUserStatus,
              insStatus: statusConst.LOGIN_REQUIRED
            };
          }
          store.commit(types.UPDATE_USER_STATUS, newUserStatus);
          //弹出login required的弹窗：
          store.dispatch(types.DIALOG_SHOW_LOGIN_REQUIRED, response.userId);
        }
      }
    }

    return Promise.reject(response);
  } else {
    return response;
  }
}
